import React, { Component } from 'react';

import { Image } from 'library';

class Header extends Component {
    render() {
        let items = [];

        if (['admin', 'owner'].includes(this.props.role)) {
            items.push(
                <li className="nav-item header-admin-link">
                    <a className="nav-link" href="/admin/">
                        Admin
                        <span className="nav-icon"></span>
                    </a>
                </li>,
            );
        }

        items.push(
            <li className="nav-item">
                <a className="nav-link" href="/logout/">
                    Logout
                </a>
            </li>,
        );

        return (
            <nav
                className="navbar navbar-expand-lg"
                style={{
                    boxShadow: '2px 2px 10px rgba(0, 0, 0, .2)',
                    marginBottom: '10px',
                }}
            >
                <div
                    className="container-fluid d-grid"
                    style={{
                        gridTemplateColumns: '1fr auto 1fr',
                        alignItems: 'center',
                    }}
                >
                    <a className="justify-self-center" href="/">
                        <Image
                            src="/static/images/tunetagger_logo_darkmode_outline.png"
                            style={{ maxHeight: '100px', opacity: '90%' }}
                        />
                    </a>

                    <a className="mx-auto" href="/">
                        <span className="header-logo-center" />
                    </a>

                    <ul className="navbar-nav ms-auto">{items}</ul>
                </div>
            </nav>
        );
    }
}

export default Header;
